export default __webpack_public_path__ + "static/media/mps.2898ec50.png";